"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderHistoryApi = exports.OrderFullfillmentApi = exports.OrderRequestsApi = exports.OrdersApi = exports.PicturesApi = exports.CatalogsExportMetadataApi = exports.CatalogApi = exports.InventoryApi = exports.CompanyApi = exports.RoleApi = exports.UserApi = exports.AuthorApi = exports.PresetApi = exports.ViewsApi = exports.AuthApi = exports.PlantOptionApi = exports.PlantApi = void 0;
const http_client_1 = __importDefault(require("./http-client"));
class MainApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.getPlants = () => this.instance.get('/plants');
        this.getPlant = (id) => this.instance.get(`/plants/${id}`);
        this.updatePlant = (id, payload) => this.instance.patch(`/plants/${id}`, payload);
        this.bulkUpdatePlant = (payload) => this.instance.patch(`/plants/update`, { updates: payload });
        this.deletePlant = (id, payload) => this.instance.delete(`/plants/${id}`, { data: payload });
        this.deletePlants = (ids) => this.instance.delete(`/plants/`, { data: { ids } });
        this.createColumn = (payload) => this.instance.post('columns', payload);
    }
}
exports.default = MainApi;
class PlantApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = () => this.instance.get('/plants');
        this.show = (id) => this.instance.get(`/plants/${id}`);
        this.create = (payload) => this.instance.post(`/plants`, payload);
        this.duplicate = (id) => this.instance.post(`/plants/duplicate`, { id });
        this.updatePlant = (id, payload) => this.instance.patch(`/plants/${id}`, payload);
        this.bulkUpdatePlant = (payload) => this.instance.patch(`/plants/bulk-update`, { updates: payload });
        this.deletePlant = (id, payload) => this.instance.delete(`/plants/${id}`, { data: payload });
        this.deletePlants = (ids) => this.instance.delete(`/plants/`, { data: { ids } });
    }
}
exports.PlantApi = PlantApi;
class PlantOptionApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = () => this.instance.get(`/plant-options/`);
        this.show = (id) => this.instance.get(`/plant-options/${id}`);
        this.create = (payload) => this.instance.post('/plant-options', payload);
        this.update = (id, payload) => this.instance.patch(`/plant-options/${id}`, payload);
        this.bulkUpdate = (payload) => this.instance.patch(`plant-options`, payload);
        this.duplicate = (id) => this.instance.post(`/qualities/duplicate`, { id });
        this.delete = (id) => {
            if (Array.isArray(id)) {
                return this.instance.delete('/plant-options', { data: { id } });
            }
            this.instance.delete(`/plant-options/${id}`);
        };
        this.checkLabel = (id, checked) => this.instance.patch(`/plant-options/${id}/check-label`, { checked: checked });
        this.validateFloramediaPictureExport = () => {
            return this.instance.get(`/export/floramedia-pictures`);
        };
    }
}
exports.PlantOptionApi = PlantOptionApi;
class AuthApi extends http_client_1.default {
    constructor() {
        super('');
        this.getCsrfCookie = () => this.instance.get('/sanctum/csrf-cookie');
        this.login = (email, password) => {
            return this.instance.get('/sanctum/csrf-cookie').then(response => {
                return this.instance.post('/auth/login', { email, password });
            });
        };
    }
}
exports.AuthApi = AuthApi;
class ViewsApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => this.instance.get('/views', { params: query });
        this.get = (id) => this.instance.get(`/views/${id}`);
        this.create = (payload) => this.instance.post('views', payload);
        this.update = (id, payload) => this.instance.patch(`/views/${id}`, payload);
        this.delete = (id) => this.instance.delete(`/views/${id}`);
    }
}
exports.ViewsApi = ViewsApi;
class PresetApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = () => this.instance.get('/presets');
        this.create = (payload) => this.instance.post('/presets', payload);
        this.update = (id, payload) => this.instance.patch(`/presets/${id}`, payload);
        this.delete = (id) => this.instance.delete(`/presets/${id}`);
    }
}
exports.PresetApi = PresetApi;
class AuthorApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => this.instance.get('/authors', { params: query });
        this.get = (id) => this.instance.get(`/authors/${id}`);
        this.create = (payload) => this.instance.post('/authors', payload);
        this.update = (id, payload) => this.instance.patch(`/authors/${id}`, payload);
    }
}
exports.AuthorApi = AuthorApi;
class UserApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => this.instance.get('/users', { params: query });
        this.get = (id) => this.instance.get(`/users/${id}`);
        this.create = (payload) => this.instance.post('/users', payload);
        this.update = (id, payload) => this.instance.patch(`/users/${id}`, payload);
    }
}
exports.UserApi = UserApi;
class RoleApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => this.instance.get('/roles', { params: query });
    }
}
exports.RoleApi = RoleApi;
class CompanyApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => {
            return this.instance.get('/companies', { params: query });
        };
        this.get = (id) => this.instance.get(`/companies/${id}`);
        this.create = (payload) => this.instance.post('/companies', payload);
        this.update = (id, payload) => this.instance.patch(`/companies/${id}`, payload);
    }
}
exports.CompanyApi = CompanyApi;
class InventoryApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => {
            return this.instance.get('/inventory', { params: query });
        };
        this.get = (ean) => this.instance.get(`/inventory/${ean}`);
        this.gridUpdate = (payload) => this.instance.patch(`/inventory`, payload);
        this.update = (id, payload) => this.instance.patch(`/plant-options/${id}/inventory/`, payload);
        this.reset = () => this.instance.post('/inventory/reset');
    }
}
exports.InventoryApi = InventoryApi;
class CatalogApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => {
            return this.instance.get('/catalogs', { params: query });
        };
        this.update = (payload) => this.instance.patch(`/catalogs`, payload);
    }
}
exports.CatalogApi = CatalogApi;
class CatalogsExportMetadataApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = () => {
            return this.instance.get('/catalogs/export/');
        };
        this.summaryIndex = () => {
            return this.instance.get('/catalogs/export/summary');
        };
        this.update = (payload) => this.instance.patch(`/catalogs/export`, payload);
        this.updateSummary = (payload) => this.instance.patch(`/catalogs/export/summary`, payload);
        this.reset = () => this.instance.patch(`catalogs/export/reset`);
    }
}
exports.CatalogsExportMetadataApi = CatalogsExportMetadataApi;
class PicturesApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (params) => this.instance.get('/pictures', { params });
        this.create = ({ modelId, authorId, file, orientation }) => {
            let formData = new FormData();
            formData.append("file", file);
            formData.append("modelId", modelId);
            formData.append("authorId", authorId);
            formData.append('orientation', orientation);
            return this.instance.post('/pictures', formData, { headers: { 'Content-Type': 'multipart/form-data' } });
        };
        this.delete = (uuid) => this.instance.delete(`/pictures/${uuid}`);
        this.update = (uuid, payload) => this.instance.patch(`/pictures/${uuid}`, payload);
    }
}
exports.PicturesApi = PicturesApi;
class OrdersApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => {
            const params = new URLSearchParams(query);
            return this.instance.get('/orders?' + params.toString());
        };
        this.get = (id) => this.instance.get(`/orders/${id}`);
        this.create = (payload) => this.instance.post('/orders', payload);
        this.update = (id, payload) => this.instance.patch(`/orders/${id}`, payload);
        this.resolve = (id) => this.instance.post(`/orders/${id}/resolve`);
        this.delete = (id) => this.instance.delete(`/orders/${id}`);
    }
}
exports.OrdersApi = OrdersApi;
class OrderRequestsApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (orderId, query = {}) => {
            return this.instance.get(`/orders/${orderId}/requests`, { params: query });
        };
        this.get = (orderId, ean) => this.instance.get(`/orders/${orderId}/requests/${ean}`);
        this.update = (orderId, ean, payload) => this.instance.patch(`/orders/${orderId}/requests/${ean}`, payload);
        this.approve = (orderId) => this.instance.patch(`/orders/${orderId}/requests/approve`);
        this.gridUpdate = (orderId, payload) => this.instance.patch(`orders/${orderId}/requests`, payload);
        this.create = (payload) => this.instance.post('/orders', payload);
    }
}
exports.OrderRequestsApi = OrderRequestsApi;
class OrderFullfillmentApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => {
            const params = new URLSearchParams(query);
            return this.instance.get('/order-fullfillments?' + params.toString());
        };
        this.get = (ean) => this.instance.get(`/order-fullfillments/${ean}`);
        this.update = (ean, payload) => this.instance.patch(`/order-fullfillments/${ean}`, payload);
        this.gridUpdate = (payload) => this.instance.patch(`/order-fullfillments`, payload);
    }
}
exports.OrderFullfillmentApi = OrderFullfillmentApi;
class OrderHistoryApi extends http_client_1.default {
    constructor() {
        super(...arguments);
        this.index = (query = {}) => {
            return this.instance.get('/order-history', { params: query });
        };
        this.get = (id) => this.instance.get(`/order-history/${id}`);
    }
}
exports.OrderHistoryApi = OrderHistoryApi;
